const Footer = (props) => {
    return (
        <div className="flex justify-center py-5 bg-white">
            Copyright © 2023 | Powered by
            <a href="https://github.com/rashmelon" className="ml-1 underline" target="_blank" rel="noreferrer"> Abdulrahman Rashwan</a>
        </div>
    )
}

export default Footer;
